import { QueryKeys } from "@/constants";
import { useQuery } from "@tanstack/react-query";
import useUserInfo from "@/hooks/use-user-info";
import type { TaxFormFetchRequest } from "@/model/taxForm";
import { fetchTaxForm } from "@/services/taxForm";

const useTaxForm = (memberId: string) => {
  const userInfo = useUserInfo();

  const fetchReqPayload: TaxFormFetchRequest = {
    groupId: userInfo?.groupId || "",
    memberId: memberId || "",
    employeeId: userInfo?.employeeId || "",
    accessToken: userInfo?.accessToken || "",
    documentType: "TaxForm",
  };

  return useQuery<unknown>({
    queryKey: [QueryKeys.TAX_FORM_FETCH],
    queryFn: async () => {
      const response = await fetchTaxForm(fetchReqPayload);
      return response;
    },
    retry: false,
    retryOnMount: false,
    enabled: Boolean(memberId) && Boolean(fetchReqPayload?.accessToken),
  });
};

export { useTaxForm };
